import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import hero from "../img/hero.png";
import hero2 from "../img/hero2.jpg";
import PRO from "../img/Pro.png";
import GitHubIcon from "@mui/icons-material/GitHub";

import { Mobile, Landscape } from "../Response";
const Hero = () => {
  const back = useSelector((state) => state.switch.back);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    window.addEventListener("scroll", ListenToScroll);
    return () => {
      window.removeEventListener("scroll", ListenToScroll);
    };
  }, []);

  const ListenToScroll = () => {
    let Y = 120;
    const WinScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (WinScroll > Y) {
      visible && setVisible(false);
    } else {
      setVisible(true);
    }
  };

  return (
    <Container>
      <Wrap>
        <Image src={back == "sun" ? hero : hero2} />
      </Wrap>
      <Pro>
        <ConIfo>
          <ProImg src={PRO} />
          <Intro>
            <WellCome className="ln" back={back}>
              HI THERE !<SEP>I'M </SEP>
            </WellCome>
            <MyName>MARIWAN AKRAM .</MyName>
            <WellCome back={back} type={"bold"}>
              A WEB DEVELOPER
            </WellCome>
          </Intro>

          <ContCon>
            {visible && (
              <>
                <GitIconLink
                  back={back}
                  href="https://github.com/Mariwan-A-MOH"
                  target="_blank"
                >
                  <GitHubIcon className="iicon" />
                </GitIconLink>
                <Button back={back} href="tel:07511828836">
                  Contact Me
                </Button>
              </>
            )}
          </ContCon>
        </ConIfo>
      </Pro>
    </Container>
  );
};
export default Hero;

const Container = styled.div`
  overflow: hidden;
  width: 100vw;
  height: 85vh;
  position: relative;
  ${Mobile({ height: "100vh" })};
  ${Landscape({ height: "100vh" })}
`;
const Wrap = styled.div`
  width: 100%;
  height: 100%;
`;
const Image = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

const Pro = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${Landscape({ alignItems: "flex-start" })}
`;

const ConIfo = styled.div`
  width: 40%;

  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
  ${Mobile({ width: "100%", gap: 10, height: "100%" })}
  ${Landscape({
    width: "80%",
    gap: 2,
    height: "100%",
    justifyContent: "flex-start",
  })}
`;
const ProImg = styled.img`
  // background: gray;
  flex: 2.4;
  // width: 100%;
  height: 90%;
  margin-top: 100px;
  overflow: hidden;

  ${Mobile({ overflow: "hidden", flex: 1 })}
  ${Landscape({ overflow: "hidden", flex: 0.8, marginTop: "55px" })}
`;
const Intro = styled.div`
  margin-top: 30px;

  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${Mobile({ flex: 0.4, marginTop: 10 })}
  ${Landscape({ flex: 0.6, marginTop: 2 })}
`;
const ContCon = styled.div`
  flex: 0.35;
  // background: #3ccd08;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: SPACE-around;
  align-items: center;
  margin-bottom: 5px;

  display: none;
  ${Mobile({
    display: "block",
    display: "flex",
    flexDirection: "column",
    justifyContent: "SPACE-around",
    alignItems: "center",
    marginBottom: "5px",
  })}
`;
const GitIconLink = styled.a`
  width: 100%;
  height: 80%;
  background: ${(props) =>
    props.back === "sun" ? "rgba(244, 251, 255, 0.7)" : "rgb(22, 28, 35,0.3)"};
  border: 1px solid
    ${(props) =>
      props.back === "sun"
        ? "rgba(226, 232, 235, 0.5)"
        : "rgba(143, 166, 168, 0.1)"};

  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  transition: all 1s;
  box-shadow: 0px 5px 9px 0px rgba(143, 166, 168, 0.2);
  ${Mobile({
    width: "82.5%",
    height: "40%",
    borderRadius: 7,
    padding: "3px",
    border: "1px solid rgba(143, 166, 168, 0.1)",
    boxShadow: "0px 3px 5px 0px rgba(143, 166, 168, 0.05)",
  })}
  :hover {
    background: ${(props) =>
      props.back === "sun"
        ? "rgba(244, 251, 255, 0.9)"
        : "rgb(22, 28, 35,0.6)"};
  }
  .iicon {
    font-size: 40px;
    transition: all 1s;
    color: ${(props) =>
      props.back === "sun"
        ? " rgba(12, 12, 28, 0.5)"
        : "rgba(244, 251, 255, 0.7)"};
    ${Mobile({ fontSize: 30 })}
    :hover {
      color: rgba(12, 12, 28, 0.7);
    }
  }
`;
const Button = styled.a`
  width: 40%;
  height: 50%;
  border: none;
  cursor: pointer;
  font-weight: 600;
  border-radius: 20px;
  // background: rgba(244, 251, 255, 0.9);
  // background: rgba(226, 232, 235, 0.5);
  background: ${(props) =>
    props.back === "sun" ? "rgba(226, 232, 235, 0.5)" : "rgba(26, 32, 39,0.8)"};

  color: ${(props) =>
    props.back === "sun"
      ? " rgba(12, 12, 28, 0.5)"
      : "rgba(244, 251, 255, 0.7)"};
  font-size: 26px;
  display: flex;
  text-decoration: none;
  justify-content: center;
  align-items: center;

  ${Mobile({
    width: "82.5%",
    height: "40%",
    borderRadius: 7,
    border: "1px solid rgba(143, 166, 168, 0.15)",
    fontSize: 18,
    letterSpacing: 1.2,
    boxShadow: "0px 3px 5px 0px rgba(143, 166, 168, 0.05)",
  })}
`;
const MyName = styled.h1`
  color: #3ccd08;
  margin: 15px;
  letter-spacing: 1.3px;
  font-weight: 800;
  font-size: 44px;
  // color: #686868;
  ${Mobile({ margin: 5, fontSize: 32, letterSpacing: 1 })}
  ${Landscape({ fontSize: 32, margin: 1 })}
`;
const WellCome = styled.h3`
  color: ${(props) =>
    props.back === "sun" ? "#7d7d7d" : " rgba(228, 236, 240, 0.847)"};

  display: flex;
  // flex-direction: column;
  justify-content: center;
  gap: 20px;
  font-size: ${(props) => (props.type ? 30 : 28)}px;
  align-items: center;
  font-weight: ${(props) => (props.type ? 800 : 400)};
  ${(props) =>
    props.type
      ? Mobile({ fontSize: 20, fontWeight: 700 })
      : Mobile({ fontSize: 24 })};
  ${(props) =>
    props.type
      ? Landscape({ fontSize: 22, fontWeight: 700 })
      : Landscape({ fontSize: 24 })};
`;
const SEP = styled.p`
  color: #3ccd08;
`;
